import { IProject } from 'redux-store/api/projects';
import { calculateBusinessDays } from 'utils/postDateHelper';

export const projectByIdMapping = (response: IProject): IProject => {
  if (!response) {
    return;
  }

  const scheduleItems = response?.phases.flatMap(({ items }) => items);

  const updatedPhases = response?.phases.map((phase) => ({
    ...phase,
    items: phase.items.map((item) => ({
      ...item,
      linkedItems: item.linkedItems
        .map((linkedItem) => {
          const targetItem = scheduleItems?.find(({ id }) => id === linkedItem?.itemId);
          const sourceItem = scheduleItems?.find(({ id }) => id === linkedItem?.predecessorId);

          if (!targetItem || !sourceItem) {
            return null;
          }

          const businessDaysDiff = calculateBusinessDays(
            sourceItem.endDate,
            targetItem.startDate,
            response.workingDays
          );

          return {
            ...linkedItem,
            workDaysDifference: businessDaysDiff - 2 < 0 ? 0 : businessDaysDiff - 2,
          };
        })
        .filter((linkedItem) => !!linkedItem),
      predecessors: item.predecessors
        .map((predecessor) => {
          const targetItem = scheduleItems?.find(({ id }) => id === predecessor?.itemId);
          const sourceItem = scheduleItems?.find(({ id }) => id === predecessor?.predecessorId);

          if (!targetItem || !sourceItem) {
            return null;
          }

          const businessDaysDiff = calculateBusinessDays(
            sourceItem.endDate,
            targetItem.startDate,
            response.workingDays
          );

          return {
            ...predecessor,
            workDaysDifference: businessDaysDiff - 2 < 0 ? 0 : businessDaysDiff - 2,
          };
        })
        .filter((predecessor) => !!predecessor),
    })),
  }));

  response.phases = updatedPhases;

  return response;
};
